/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type InspectionReportEnum = 1 | 2 | 3 | 4 | 5;

export const InspectionReportEnum = {
    NUMBER_1: 1 as InspectionReportEnum,
    NUMBER_2: 2 as InspectionReportEnum,
    NUMBER_3: 3 as InspectionReportEnum,
    NUMBER_4: 4 as InspectionReportEnum,
    NUMBER_5: 5 as InspectionReportEnum
};

